import React from 'react';
import { useController } from 'react-hook-form';

import PhoneNumberInput from '../../../components/PhoneNumberInput/PhoneNumberInput';

const ControlledPhoneNumberInput = ({ isSmallScreen }: ControlledPhoneNumberInputProps) => {
	const { field, fieldState } = useController({
		name: 'phone',
	});

	return (
		<PhoneNumberInput
			formError={fieldState.error}
			value={field.value}
			onChange={field.onChange}
			onBlur={field.onBlur}
			isSmallScreen={isSmallScreen}
			//@ts-ignore
			ref={field.ref}
		/>
	);
};

export default ControlledPhoneNumberInput;

interface ControlledPhoneNumberInputProps {
	isSmallScreen: boolean;
}
